module.exports = __webpack_public_path__ + "img/g5.635359a4.jpg";